export default "__VITE_PUBLIC_ASSET__a4b40687__"